import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const LUMP_SUM_PRICES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('LUMP_SUM_PRICES');
export const LUMP_SUM_PRICES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	LUMP_SUM_PRICES_CRUD_ACTION_CONSTANTS
);
